import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import PendingOrders from './Pages/PendingOrders';
import Dashboard from './Pages/Dashboard';
import AllOrders from './Pages/AllOrders';
import Categories from './Pages/Categories';
import Products from './Pages/Products';
import Customers from './Pages/Customers';
import Drivers from './Pages/Drivers';
import Support from './Pages/Support';
import Notifications from './Pages/Notifications';
import AppDetails from './Pages/AppDetails';
import Banners from './Pages/Banners';
import Business from './Pages/Business';
import Login from './Pages/Login';
import AsyncStorage from '@react-native-async-storage/async-storage';
import PromoCode from './Pages/PromoCode';
import SubCategories from './Pages/SubCategories';
import SockJsClient from 'react-stomp';
import WebSocketComponent from './WebSocketComponent';
import BusinessSettings from './Pages/BusinessSettings';
import ListNotifications from './Pages/ListNotifications';
import OrderDetails from './Pages/OrderDetails';
import PrivacyPolicy from './Pages/privacyPolicy';



function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null); // Set initial state to null for loading state

  const [token, setToken]= useState()

  window.onerror = function (message, source, lineno, colno, error) {
    // Handle error
    console.error('Global Error:', message, source, lineno, colno, error);
    return true; // Prevent the default browser behavior (suppress the error)
  };
  

  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        const myUser = await AsyncStorage.getItem('myUser');
        if (myUser) {
          const parsedUser = JSON.parse(myUser);
          setIsLoggedIn(parsedUser && parsedUser.isLoggedIn);
          setToken(parsedUser.token)
        } else {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error reading AsyncStorage:", error);
        setIsLoggedIn(false);
      }
    };

    checkLoginStatus();
  }, []);

  // Return loading state until isLoggedIn is determined
  if (isLoggedIn === null) {
    return <div>Loading...</div>; // Replace this with a spinner or skeleton screen if preferred
  }

  return (
    <Router>
  
      <Routes>
        {/* If logged in, show app routes */}
        {isLoggedIn ? (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/pending-orders" element={<PendingOrders />} />
            <Route path="/all-orders" element={<AllOrders />} />
            <Route path="/report" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/menu" element={<Products />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/drivers" element={<Drivers />} />
            <Route path="/support" element={<Support />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/app-details" element={<AppDetails />} />
            <Route path="/banners" element={<Banners />} />
            <Route path="/businesses" element={<Business />} />
            <Route path="/promoCode" element={<PromoCode />} />
            <Route path="/subCategories" element={<SubCategories />} />
            <Route path="/settings" element={<BusinessSettings />} />
            <Route path="/order/:id" element={<OrderDetails />} />
            <Route path="/listNotifications" element={<ListNotifications />} />
            {/* Redirect to PendingOrders if user tries to visit the home page */}
            <Route path="/" element={<Navigate to="/pending-orders" />} />
          </>
        ) : (
          <>
            {/* If not logged in, show the login page */}
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/pending-orders" element={<PendingOrders />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/order/:id" element={<OrderDetails />} />
            {/* Redirect all other routes to login */}
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}
      </Routes>

    </Router>
  );
}

export default App;
